module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.1@core-js/modules/_library.js
// module id = 37
// module chunks = 0